import React, { Component } from "react";
import { apiFetch } from "apiFetch";
import ForgotPasswordLayout from "auth/components/forgot-password-layout";

class ForgotPassword extends Component {
  handleSubmit = event => {
    event.preventDefault();

    const email = encodeURIComponent(event.target.email.value);

    apiFetch(`/api/password/resetToken?email=${email}`, { method: "POST", rawResponse: true })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(() => {
        this.setState({
          showSuccessMessage: true
        });
      })
      .catch(() => {
        this.setState({
          showErrorMessage: true
        });
      });
  };

  render() {
    return (
      <ForgotPasswordLayout {...this.state} handleSubmit={this.handleSubmit} />
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/auth/containers/forgot-password.js